export default {
  'menu.dashboard': '数据概览',
  'menu.user': '用户管理',
  'menu.finance': '财务管理',
  'menu.model': '模型管理',
  'menu.system': '系统配置',
  'menu.billing': '计费管理',
  'menu.system.sms': '短信配置',
};
